import {websiteName} from "../../config";
import {Helmet} from "react-helmet";

const Page = (props) => {
    return (
        <>
            <Helmet>
                <title>{`${websiteName} | ` + props.title || websiteName}</title>
                <meta name="description" content="Stay up to date with the best rewards!"/>
            </Helmet>
            {props.children}
        </>);
};

export default Page;